module.exports = "/images/vendor/flag-icon-css/flags/4x3/jm.svg?67f96b2f0df34ce53d7651ade04d1e0b";